import { Box, useTheme } from '@mui/material';
import { LineChart } from '@mui/x-charts/LineChart';
import { useEffect, useState } from 'react';

type DataPoint = {
    fecha: string;
    total: number;
};

type Props = {
    data: DataPoint[];
};

export default function VentasChart({ data }: Props) {
    const theme = useTheme();
    const [chartWidth, setChartWidth] = useState(800);
    
    useEffect(() => {
        const updateWidth = () => {
            const container = document.getElementById('ventas-chart');
            if (container) {
                const containerWidth = container.offsetWidth;
                // Restar padding (16px * 2) y usar el 95% del ancho disponible
                const width = Math.max(600, Math.min((containerWidth - 32) * 0.95, 1200));
                setChartWidth(width);
            }
        };
        
        updateWidth();
        window.addEventListener('resize', updateWidth);
        return () => window.removeEventListener('resize', updateWidth);
    }, []);
    
    return (
        <Box 
            id={`ventas-chart`} 
            sx={{ 
                background: theme.palette.background.paper,
                borderRadius: 1,
                p: 2,
                border: `1px solid ${theme.palette.divider}`,
                width: '100%',
                overflow: 'auto',
            }}
        >
            <LineChart
                xAxis={[{
                    data: data.map((item) => item.fecha),
                    scaleType: 'band',
                    label: 'Fecha',
                    labelStyle: {
                        fill: theme.palette.text.primary,
                    },
                    tickLabelStyle: {
                        fill: theme.palette.text.secondary,
                    },
                }]}
                yAxis={[{
                    label: 'Total',
                    labelStyle: {
                        fill: theme.palette.text.primary,
                    },
                    tickLabelStyle: {
                        fill: theme.palette.text.secondary,
                    },
                }]}
                series={[
                    {
                        data: data.map((item) => item.total),
                        color: theme.palette.primary.main,
                    },
                ]}
                width={chartWidth}
                height={300}
                sx={{
                    '& .MuiChartsAxis-root': {
                        stroke: theme.palette.divider,
                    },
                    '& .MuiChartsGrid-root': {
                        stroke: theme.palette.divider,
                    },
                    '& .MuiChartsAxis-tick': {
                        stroke: theme.palette.divider,
                    },
                    '& .MuiChartsAxis-line': {
                        stroke: theme.palette.divider,
                    },
                }}
            />
        </Box>
    );
}
